/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to specify the width of a status bar widget.
 * <br><br>
 * @module MW/statusbar/RegionMixin
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {

        width: 0,

        _setWidthAttr: function (value) {
            if (value > 0) {
                this.domNode.style.width = value + "px";
            }
            this._set("width", value);
        }
    });
});

